module.exports = __webpack_public_path__ + "img/xinhua-net.6bb3437a.png";